export default __webpack_public_path__ + "static/media/section2_background@2x.4e7a2829.png";